// carriers stream: keys are merged into the app dictionary by locales/index.ts.
export const en: Record<string, string> = {
  "carriers.title": "Carriers",
  "carriers.subtitle": "Who the agency works with and how their data would reach this desk. Nothing here is a live connection until it is verified.",
  "carriers.simulated": "Simulated",
  "carriers.simulatedNote": "Fictional carrier. Scripted responses, no real carrier is contacted.",
  "carriers.state.demo": "Demo",
  "carriers.state.not_connected": "Not connected",
  "carriers.state.ready_for_setup": "Ready for setup",
  "carriers.state.test": "Test",
  "carriers.state.live": "Live",
  "carriers.verification.not_verified": "Connection not verified",
  "carriers.verification.agency_confirmed": "Confirmed by the agency",
  "carriers.verification.documented": "Documented",
  "carriers.kind.carrier": "Carrier",
  "carriers.kind.mga": "MGA",
  "carriers.kind.wholesaler": "Wholesaler",
  "carriers.col.carrier": "Carrier / MGA",
  "carriers.col.method": "Proposed method",
  "carriers.col.scope": "States · lines",
  "carriers.col.formats": "Formats",
  "carriers.col.status": "Status",
  "carriers.add": "Add carrier",
  "carriers.edit": "Edit profile",
  "carriers.name": "Name",
  "carriers.naic": "NAIC (optional)",
  "carriers.agencyCode": "Agency code",
  "carriers.producerCodes": "Producer codes",
  "carriers.states": "States (comma separated)",
  "carriers.lines": "Lines",
  "carriers.method": "Proposed connection method",
  "carriers.formats": "Known file formats (comma separated: al3, csv, xlsx, pdf)",
  "carriers.portalUrl": "Portal URL (optional)",
  "carriers.verificationLabel": "Verification",
  "carriers.autoImport": "Auto-import files that arrive with no exceptions",
  "carriers.notes": "Notes",
  "carriers.requiredInfo": "Required information",
  "carriers.requiredInfo.help": "What this carrier needs from the agency. Only enter what their documentation says; leave unknown blank.",
  "carriers.requiredInfo.label": "Item",
  "carriers.requiredInfo.value": "Value",
  "carriers.requiredInfo.source": "Source",
  "carriers.source.agency": "Agency",
  "carriers.source.carrier_doc": "Carrier documentation",
  "carriers.source.unknown": "Unknown",
  "carriers.addRow": "Add item",
  "carriers.saved": "Carrier profile saved",
  "carriers.statusNote": "Status is set by the server when a connection is verified. Editing a profile never makes it live.",
  "carriers.demo.title": "Demo carrier workflow",
  "carriers.demo.sub": "Send a request to the simulated carrier, answer what it asks, and watch the file flow through the real import pipeline.",
  "carriers.demo.customer": "Customer",
  "carriers.demo.searchCustomer": "Search a customer…",
  "carriers.demo.policy": "Policy",
  "carriers.demo.noPolicy": "No policy (new business only)",
  "carriers.demo.kind": "Request",
  "carriers.kind.policy_download": "Policy download",
  "carriers.kind.endorsement": "Endorsement",
  "carriers.kind.renewal_quote": "Renewal quote",
  "carriers.kind.new_business": "New business",
  "carriers.demo.create": "Prepare request",
  "carriers.demo.createdSubmitted": "Request prepared and submitted to the simulator",
  "carriers.requests": "Requests",
  "carriers.requests.none": "No carrier requests yet.",
  "carriers.status.draft": "Draft",
  "carriers.status.submitted": "Submitted",
  "carriers.status.needs_info": "Carrier needs info",
  "carriers.status.processing": "Processing",
  "carriers.status.file_ready": "File ready",
  "carriers.status.downloading": "Downloading",
  "carriers.status.imported": "Imported",
  "carriers.status.failed": "Failed",
  "carriers.request.title": "Carrier request",
  "carriers.request.banner": "SIMULATED — this is a fictional carrier response generated for the demo. No real carrier was contacted.",
  "carriers.request.timeline": "Timeline",
  "carriers.request.question": "The carrier asks",
  "carriers.request.answerPlaceholder": "Type the answer…",
  "carriers.request.answer": "Send answer",
  "carriers.request.answered": "Answer saved; the simulator is processing",
  "carriers.request.submit": "Submit to carrier",
  "carriers.request.fetchDirect": "Fetch file (direct)",
  "carriers.request.fetchExecutor": "Fetch through Faraday executor",
  "carriers.request.fetched": "File fetched and imported",
  "carriers.request.queued": "Handed to a Faraday executor; this page refreshes while it works",
  "carriers.request.file": "Carrier file",
  "carriers.request.download": "Download file",
  "carriers.request.import": "Import batch",
  "carriers.request.openBatch": "Open batch",
  "carriers.request.customer": "Customer",
  "carriers.request.policy": "Policy",
  "carriers.request.job": "Executor job",
  "carriers.request.followUp": "A follow-up task \"Review carrier changes\" was created and the import summary was noted on the customer file.",
  "carriers.request.notVerified": "This carrier is not verified; requests cannot be sent.",
  "carriers.panel.title": "Carrier requests",
  "carriers.panel.new": "New carrier request",
  "carriers.panel.none": "No carrier requests for this customer.",
  "carriers.methods.title": "Connection methods",
};

export const es: Record<string, string> = {
  "carriers.title": "Aseguradoras",
  "carriers.subtitle": "Con quién trabaja la agencia y cómo llegarían sus datos a este escritorio. Nada aquí es una conexión en vivo hasta que se verifique.",
  "carriers.simulated": "Simulado",
  "carriers.simulatedNote": "Aseguradora ficticia. Respuestas guionadas; no se contacta a ninguna aseguradora real.",
  "carriers.state.demo": "Demo",
  "carriers.state.not_connected": "Sin conexión",
  "carriers.state.ready_for_setup": "Lista para configurar",
  "carriers.state.test": "Prueba",
  "carriers.state.live": "En vivo",
  "carriers.verification.not_verified": "Conexión no verificada",
  "carriers.verification.agency_confirmed": "Confirmada por la agencia",
  "carriers.verification.documented": "Documentada",
  "carriers.kind.carrier": "Aseguradora",
  "carriers.kind.mga": "MGA",
  "carriers.kind.wholesaler": "Mayorista",
  "carriers.col.carrier": "Aseguradora / MGA",
  "carriers.col.method": "Método propuesto",
  "carriers.col.scope": "Estados · líneas",
  "carriers.col.formats": "Formatos",
  "carriers.col.status": "Estado",
  "carriers.add": "Agregar aseguradora",
  "carriers.edit": "Editar perfil",
  "carriers.name": "Nombre",
  "carriers.naic": "NAIC (opcional)",
  "carriers.agencyCode": "Código de agencia",
  "carriers.producerCodes": "Códigos de productor",
  "carriers.states": "Estados (separados por coma)",
  "carriers.lines": "Líneas",
  "carriers.method": "Método de conexión propuesto",
  "carriers.formats": "Formatos conocidos (separados por coma: al3, csv, xlsx, pdf)",
  "carriers.portalUrl": "URL del portal (opcional)",
  "carriers.verificationLabel": "Verificación",
  "carriers.autoImport": "Importar automáticamente archivos sin excepciones",
  "carriers.notes": "Notas",
  "carriers.requiredInfo": "Información requerida",
  "carriers.requiredInfo.help": "Lo que esta aseguradora necesita de la agencia. Solo ingrese lo que diga su documentación; deje en blanco lo desconocido.",
  "carriers.requiredInfo.label": "Elemento",
  "carriers.requiredInfo.value": "Valor",
  "carriers.requiredInfo.source": "Fuente",
  "carriers.source.agency": "Agencia",
  "carriers.source.carrier_doc": "Documentación de la aseguradora",
  "carriers.source.unknown": "Desconocido",
  "carriers.addRow": "Agregar elemento",
  "carriers.saved": "Perfil de aseguradora guardado",
  "carriers.statusNote": "El estado lo fija el servidor cuando se verifica una conexión. Editar un perfil nunca lo pone en vivo.",
  "carriers.demo.title": "Flujo de aseguradora de demostración",
  "carriers.demo.sub": "Envíe una solicitud a la aseguradora simulada, responda lo que pida y vea el archivo pasar por el proceso real de importación.",
  "carriers.demo.customer": "Cliente",
  "carriers.demo.searchCustomer": "Buscar un cliente…",
  "carriers.demo.policy": "Póliza",
  "carriers.demo.noPolicy": "Sin póliza (solo negocio nuevo)",
  "carriers.demo.kind": "Solicitud",
  "carriers.kind.policy_download": "Descarga de póliza",
  "carriers.kind.endorsement": "Endoso",
  "carriers.kind.renewal_quote": "Cotización de renovación",
  "carriers.kind.new_business": "Negocio nuevo",
  "carriers.demo.create": "Preparar solicitud",
  "carriers.demo.createdSubmitted": "Solicitud preparada y enviada al simulador",
  "carriers.requests": "Solicitudes",
  "carriers.requests.none": "Aún no hay solicitudes a aseguradoras.",
  "carriers.status.draft": "Borrador",
  "carriers.status.submitted": "Enviada",
  "carriers.status.needs_info": "La aseguradora pide datos",
  "carriers.status.processing": "En proceso",
  "carriers.status.file_ready": "Archivo listo",
  "carriers.status.downloading": "Descargando",
  "carriers.status.imported": "Importado",
  "carriers.status.failed": "Falló",
  "carriers.request.title": "Solicitud a aseguradora",
  "carriers.request.banner": "SIMULADO — esta es una respuesta ficticia generada para la demostración. No se contactó a ninguna aseguradora real.",
  "carriers.request.timeline": "Cronología",
  "carriers.request.question": "La aseguradora pregunta",
  "carriers.request.answerPlaceholder": "Escriba la respuesta…",
  "carriers.request.answer": "Enviar respuesta",
  "carriers.request.answered": "Respuesta guardada; el simulador está procesando",
  "carriers.request.submit": "Enviar a la aseguradora",
  "carriers.request.fetchDirect": "Obtener archivo (directo)",
  "carriers.request.fetchExecutor": "Obtener con el ejecutor Faraday",
  "carriers.request.fetched": "Archivo obtenido e importado",
  "carriers.request.queued": "Entregado a un ejecutor Faraday; esta página se actualiza mientras trabaja",
  "carriers.request.file": "Archivo de la aseguradora",
  "carriers.request.download": "Descargar archivo",
  "carriers.request.import": "Lote de importación",
  "carriers.request.openBatch": "Abrir lote",
  "carriers.request.customer": "Cliente",
  "carriers.request.policy": "Póliza",
  "carriers.request.job": "Trabajo del ejecutor",
  "carriers.request.followUp": "Se creó la tarea \"Revisar cambios de la aseguradora\" y el resumen de importación quedó anotado en el expediente.",
  "carriers.request.notVerified": "Esta aseguradora no está verificada; no se pueden enviar solicitudes.",
  "carriers.panel.title": "Solicitudes a aseguradoras",
  "carriers.panel.new": "Nueva solicitud",
  "carriers.panel.none": "No hay solicitudes a aseguradoras para este cliente.",
  "carriers.methods.title": "Métodos de conexión",
};
